import { AmendmentExtended, AmendmentStatusIds, AmendmentTypes } from '@xemplo/gp-types';

export const amendmentCanBeRemoved = (amendment?: AmendmentExtended) => {
  if (!amendment) return false;
  const amendmentStatusId = amendment.amendmentStatusId;
  if (amendment.amendmentTypeId === AmendmentTypes.PAYRUN)
    return (
      amendmentStatusId === AmendmentStatusIds.CREATED ||
      amendmentStatusId === AmendmentStatusIds.DRAFT ||
      amendmentStatusId === AmendmentStatusIds.UPDATED
    );
  return (
    amendmentStatusId === AmendmentStatusIds.CREATED ||
    amendmentStatusId === AmendmentStatusIds.REJECTED ||
    amendmentStatusId === AmendmentStatusIds.UPDATED
  );
};
